<template>
    <div class="user">
        <!-- <header>
            <Header />
        </header> -->
        <!-- 需求用户 -->
        <div class="user-content-box">
            <div class="content-box-data">
                <!-- <div class="user-box">
                    <div class="user-box-title">个人中心</div>
                    <div class="user-box-desc">管理您的账户信息和安全设置</div>
                </div> -->
                <!-- 需求用户-个人-个人中心 -->
                <el-card class="box-card" v-if="cloud_login_user_role == '1'">
                    <div class="box-card-title">用户信息</div>
                    <template>
                        <el-form ref="form" :model="userInfoData" label-width="80px" class="user-form">
                            <el-form-item label="账户名称">
                                <el-input v-model="userInfoData.userName" class="handle-input"></el-input>
                            </el-form-item>
                            <el-form-item label="联系电话">
                                <el-input v-model="userInfoData.phone" class="handle-input"></el-input>
                            </el-form-item>
                            <el-form-item label="用户名">
                                <el-input v-model="userInfoData.account" class="handle-input"></el-input>
                            </el-form-item>
                            <el-form-item label="电子邮箱">
                                <el-input v-model="userInfoData.email" class="handle-input"></el-input>
                            </el-form-item>
                            <el-form-item label="密码">
                                <el-button type="danger" @click="getUpdatePassWord">修改 密码</el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="updateDemandUser">更 新</el-button>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-card>
                <!-- 需求用户-公司-个人中心 -->
                <el-card v-if="cloud_login_user_role == '2'">
                    <template>
                        <el-form ref="form" :model="userInfoData" label-width="100px" class="user-form">
                            <el-form-item label="公司名称">
                                <el-input v-model="userInfoData.company" class="handle-input"></el-input>
                            </el-form-item>
                            <el-form-item label="联系人">
                                <el-input v-model="userInfoData.linkName" class="handle-input"></el-input>
                            </el-form-item>
                            <el-form-item label="联系电话">
                                <el-input v-model="userInfoData.linkPhone" class="handle-input"></el-input>
                            </el-form-item>
                            <el-form-item label="身份证号码">
                                <el-input v-model="userInfoData.idCard" class="handle-input"></el-input>
                            </el-form-item>
                            <el-form-item label="营业执照">
                                <el-image 
                                    style="width: 100px; height: 100px"
                                    :src="userInfoData.businessLicense" 
                                    >
                                </el-image>
                                <el-upload
                                    class="upload-demo"
                                    drag
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    multiple>
                                    <i class="el-icon-upload"></i>
                                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="电子邮箱">
                                <el-input v-model="userInfoData.email" class="handle-input"></el-input>
                            </el-form-item>
                            <el-form-item label="用户名">
                                <el-input v-model="userInfoData.account" class="handle-input"></el-input>
                            </el-form-item>
                            <el-form-item label="密码">
                                <el-button type="danger" @click="getUpdatePassWord">修改 密码</el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="updateDemandCompanyUser">更 新</el-button>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-card>
                <!-- 资源用户 -->
                <el-card class="box-card" v-if="cloud_login_user_role == '3'">
                    <div class="box-card-title">用户信息</div>
                    
                    <el-form ref="form" :model="userInfoData" label-width="100px" class="user-form">
                        <el-form-item label="公司名称">
                            <el-input v-model="userInfoData.company" class="handle-input" placeholder="请输入公司名称"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人">
                            <el-input v-model="userInfoData.linkName" class="handle-input" placeholder="请输入联系人"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话">
                            <el-input v-model="userInfoData.linkPhone" class="handle-input" placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号码">
                            <el-input v-model="userInfoData.idCard" class="handle-input" placeholder="请输入身份证号码"></el-input>
                        </el-form-item>
                        <el-form-item label="营业执照">
                            <el-image 
                                style="width: 100px; height: 100px"
                                :src="userInfoData.businessLicense" 
                                >
                            </el-image>
                            <el-upload
                                class="upload-demo"
                                drag
                                action="https://jsonplaceholder.typicode.com/posts/"
                                multiple>
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="电子邮箱" >
                            <el-input v-model="userInfoData.email" class="handle-input" placeholder="请输入电子邮箱"></el-input>
                        </el-form-item>
                        <el-form-item label="用户名">
                            <el-input v-model="userInfoData.account" class="handle-input" placeholder="请输入用户名"></el-input>
                        </el-form-item>
                        <el-form-item label="密码">
                            <el-button type="danger" @click="getUpdatePassWord">修改 密码</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="updateResourceUser">更 新</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
                <!-- 渠道商用户 -->
                <el-card class="box-card" v-if="cloud_login_user_role == '4'">
                    <div class="box-card-title">用户信息</div>
                    
                    <el-form ref="form" :model="userInfoData" label-width="100px" class="user-form">
                        <el-form-item label="公司名称">
                            <el-input v-model="userInfoData.company" class="handle-input" placeholder="请输入公司名称"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人">
                            <el-input v-model="userInfoData.linkName" class="handle-input" placeholder="请输入联系人"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话">
                            <el-input v-model="userInfoData.linkPhone" class="handle-input" placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号码">
                            <el-input v-model="userInfoData.idCard" class="handle-input" placeholder="请输入身份证号码"></el-input>
                        </el-form-item>
                        <el-form-item label="营业执照">
                            <el-image 
                                style="width: 100px; height: 100px"
                                :src="userInfoData.businessLicense" 
                                >
                            </el-image>
                            <el-upload
                                class="upload-demo"
                                drag
                                action="https://jsonplaceholder.typicode.com/posts/"
                                multiple>
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="电子邮箱" >
                            <el-input v-model="userInfoData.email" class="handle-input" placeholder="请输入电子邮箱"></el-input>
                        </el-form-item>
                        <el-form-item label="用户名">
                            <el-input v-model="userInfoData.account" class="handle-input" placeholder="请输入用户名"></el-input>
                        </el-form-item>
                        <el-form-item label="密码">
                            <el-button type="danger" @click="getUpdatePassWord">修改 密码</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="updateResourceUser">更 新</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </div>
            <el-dialog title="修改密码" :visible.sync="dialogVisiblePassWord" width="500px">
                <el-form :model="form" label-width="80px">
                    <el-form-item label="旧密码" >
                        <el-input v-model="form.oldPassword" placeholder="请输入旧密码"></el-input>

                    </el-form-item>
                    <el-form-item label="新密码">
                        <el-input v-model="form.password" placeholder="请输入新密码"></el-input>

                    </el-form-item>
                    <el-form-item label="确认密码">
                        <el-input v-model="form.confirmPassword" placeholder="请输入确认密码"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisiblePassWord = false">取 消</el-button>
                    <el-button type="primary" @click="saveUsePassWord">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
/**
 * 需求用户、资源用户、渠道用户
 * 需求用户 个人信息 区分为个人账号和企业账号
 * 资源用户 个人信息 展示个人账号信息
 * 渠道用户 个人信息 展示个人账号信息
*/
import {
    userInfo,
    resourceUserInfo,
    demandCompanyUserInfo,
    updateDemandUserInfo,
    updateDemandCompany,
    updateResourceUserInfo,
    updateResourcePassword,
    updateDemandPassword,
    updateDemandCompanyPassword
} from '@/api/index'
export default {
    data() {
        return {
            cloud_login_user_role:sessionStorage.getItem('cloud_login_user_role'),//用户权限 /1个人需求 2公司需求 3资源 4渠道
            userInfoData:{},
            dialogVisiblePassWord:false,
            form:{
                oldPassword:'',//旧密码
                password:'',//新密码
                confirmPassword:'',//确认密码
            }
        };
    },

    mounted() {
        this.getUser();
    },

    methods: {
        getUser(){
            // /1个人需求 2公司需求 3资源 4渠道
            if(this.cloud_login_user_role == 1){
                this.getUserInfo();
            }else if(this.cloud_login_user_role == 3){
                this.getResourceUserInfo();
            }else if(this.cloud_login_user_role == 2){
                this.getDemandCompanyUserInfo();
            }
        },
        // userInfo 1个人-需求
        getUserInfo(){
            userInfo().then(res=>{
                if(res.success){
                    this.userInfoData = res.data;
                }
            })
        },
        // userInfo 3资源用户
        getResourceUserInfo(){
            resourceUserInfo().then(res=>{
                if(res.success){
                    this.userInfoData = res.data;
                }
            })
        },
        // userInfo 2公司-需求
        getDemandCompanyUserInfo(){
            demandCompanyUserInfo().then(res=>{
                if(res.success){
                    this.userInfoData = res.data;
                }
            })
        },
        //更新-需求用户-个人
        updateDemandUser(){
            let data = {
                account:this.userInfoData.account,
                email:this.userInfoData.email,
                userName:this.userInfoData.userName,
                phone:this.userInfoData.phone,
                email:this.userInfoData.email,
            }
            updateDemandUserInfo(data).then(res=>{
                if(res.data){
                    this.$message({
                        message: '更新成功',
                        type: 'success'
                    });
                    this.getUserInfo();
                }else{
                    this.$message({
                        message: '更新失败',
                        type: 'error'
                    })
                }
            })
        },
        //更新-需求用户-公司
        updateDemandCompanyUser(){
            let data = {
                account:this.userInfoData.account,
                businessLicense:this.userInfoData.businessLicense,
                company:this.userInfoData.company,
                email:this.userInfoData.email,
                idCard:this.userInfoData.idCard,
                linkName:this.userInfoData.linkName,
                linkPhone:this.userInfoData.linkPhone,
            }
            updateDemandCompany(data).then(res=>{
                if(res.data){
                    this.$message({
                        message: '更新成功',
                        type: 'success'
                    });
                    this.getDemandCompanyUserInfo();
                }else{
                    this.$message({
                        message: '更新失败',
                        type: 'error'
                    })
                }
            })
        },
        //更新-资源用户
        updateResourceUser(){
            let data = {
                account:this.userInfoData.account,
                businessLicense:this.userInfoData.businessLicense,
                company:this.userInfoData.company,
                email:this.userInfoData.email,
                idCard:this.userInfoData.idCard,
                linkName:this.userInfoData.linkName,
                linkPhone:this.userInfoData.linkPhone,
            }
            updateResourceUserInfo(data).then(res=>{
                if(res.data){
                    this.$message({
                        message: '更新成功',
                        type: 'success'
                    });
                    this.getResourceUserInfo();
                }else{
                    this.$message({
                        message: '更新失败',
                        type: 'error'
                    })
                }
            })
        },
        //唤起修改密码 弹窗
        getUpdatePassWord(){
            this.dialogVisiblePassWord = true;
            
        },
        //保存新密码
        saveUsePassWord(){
            // /1个人需求 2公司需求 3资源 4渠道
            if(this.cloud_login_user_role == 1){
                this.getUpdatePassWordDemand();
            }else if(this.cloud_login_user_role == 3){
                this.getUpdatePassWordResource();
            }else if(this.cloud_login_user_role == 2){
                this.getUpdatePassWordDemandCompany();
            }
        },
        //修改密码 - 资源用户
        getUpdatePassWordResource(){
            let data = {
                oldPassword:this.form.oldPassword,
                newPassword:this.form.password,
            }
            updateResourcePassword(data).then(res=>{
                if(res.data){
                    this.$message({
                        message: '更新成功',
                        type: 'success'
                    });
                    this.dialogVisiblePassWord = false;
                }else{
                    this.$message({
                        message: '更新失败',
                        type: 'error'
                    })
                }
            })
        },
        //修改密码 - 需求-个人
        getUpdatePassWordDemand(){
            let data = {
                oldPassword:this.form.oldPassword,
                newPassword:this.form.password,
            }
            updateDemandPassword(data).then(res=>{
                if(res.data){
                    this.$message({
                        message: '更新成功',
                        type: 'success'
                    });
                    this.dialogVisiblePassWord = false;
                }else{
                    this.$message({
                        message: '更新失败',
                        type: 'error'
                    })
                }
            })
        },
        //修改密码-需求-公司
        getUpdatePassWordDemandCompany(){
            let data = {
                oldPassword:this.form.oldPassword,
                newPassword:this.form.password,
            }
            updateDemandCompanyPassword(data).then(res=>{
                if(res.data){
                    this.$message({
                        message: '更新成功',
                        type: 'success'
                    });
                    this.dialogVisiblePassWord = false;
                }else{
                    this.$message({
                        message: '更新失败',
                        type: 'error'
                    })
                }
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.user-content-box{
    width: 100%;
	height:auto;
    min-height:calc(100vh - 140px);
	padding:30px 0 20px;
	background-color: #f9fafb;
    .content-box-data{
        width:80%;
        height:auto;
        margin:0 auto;
        // background-color:#fff;
        // .user-box{
        //     width:100%;
        //     height:auto;
        //     margin-bottom:20px;
        //     box-sizing: border-box;
        //     padding:20px 20px;
        //     border-radius:5px;
        //     box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        //     background-color:#fff;
        //     .user-box-title{
        //         font-size:1.25rem;
        //         font-weight:600;
        //         color:#000;
        //     }
        //     .user-box-desc{
        //         font-size:0.8rem;
        //         color:#666;
        //         margin-top:10px;
        //     }
        // }
        .box-card-title{
            width: 100%;
            font-size:0.8rem;
            font-weight:600;
            text-align: center;
            margin-bottom:20px;
        }
        .user-form{
            width:500px;
            height:auto;
            margin:0 auto;
        }
    }
}
</style>

<style scoped>
.handle-input{
    width:320px;
}
</style>